@if (showField$ | async) {
  <mat-form-field [floatLabel]="field.floatLabel || 'auto'">
    <mat-label>{{ field.label | translate }}</mat-label>
    <mat-select [formControl]="$any(field.control)" [required]="!!field.validators?.required" multiple>
      <mat-select-trigger>
        {{ getSelectedDisplay(field.control.value, field.options) }}
      </mat-select-trigger>
      @for (option of field.options; track option) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
